import fireError from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { FireErrorAttributes } from './types.tsx';

export const fireErrorAnalytics = (attributes: FireErrorAttributes, error: Error) => {
	fireError({
		meta: {
			packageName: 'jiraSoftwareCustomerTemplates',
			teamName: 'jlove-makkuro',
			id: 'jiraSoftwareCustomerTemplates',
		},
		attributes,
		error,
	});
};
